import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "width", "height", "fill"];
import React from 'react';

var GlassIcon = function GlassIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'skyblue' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: className,
    width: width,
    height: height
  }, props, {
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "10",
    fill: fill
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boltui-icon__glass-gradient",
    x1: "3.4%",
    x2: "86.1%",
    y1: "93.2%",
    y2: "18.7%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: "1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: "0",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#boltui-icon__glass-gradient)",
    d: "M3.5 14.7c-1 0-1.8 0-2.8-.2l-1-.3C-.8 13-1 11.7-1 10.4c0-6 5-11 11-11 4.4 0 8 2.3 10 6-2 4.8-7.6 7.8-12.5 9-1.3.2-2.6.3-4 .3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeOpacity: ".4",
    d: "M3.5 14.2c1.3 0 2.5 0 4-.4 5.5-1.2 10.3-4.3 12-8.5C17.5 2 14-.2 10-.2 4.4-.2-.4 4.6-.4 10.4c0 1.2.2 2.3.5 3.4.3 0 .6 0 .8.2l2.7.2z"
  })));
};

GlassIcon.displayName = 'GlassIcon';
export default GlassIcon;